import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {carouselEnum} from '@app/components/carousel/iCarousel';
import {HttpService} from '@app/core';
import {TokenService} from '@app/core/token/token.service';
import {IndicatorService} from '@app/shared';
import {forkJoin, Subscription} from 'rxjs';
import {map} from 'rxjs/operators';
import {iModalSummary, ISubscriptionStatus} from './iModelSummary';
import {NavigationBarService} from "@app/shared/navigation-bar/navigation-bar.service";
import {LibraryService} from "@app/app/library/library.service";

@Component({
  selector: 'navaar-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.scss']
})
export class LibraryComponent implements OnInit, OnDestroy {

  public subscription: Subscription = new Subscription();
  public container: HTMLDivElement;
  public isLogin: boolean;
  public isShowContextMenu: boolean = false;
  public subscriptionContextMenu: ISubscriptionStatus = null;
  public identifierContextMenu: number;
  public audiobookIdContextMenu: string;
  public audiobookTitleContextMenu: string;
  public tabNameContextMenu: 'bookmark' | 'library';
  public boughtsItem: Array<iModalSummary> = [];
  public bookmarkItem: Array<iModalSummary> = [];
  public carouselType: typeof carouselEnum = carouselEnum;
  public isLoading: boolean = true;
  public isOwner: boolean | null;
  public visible: boolean = false;
  public sortListSelected: { title: string, type: string } = {
    title: "تازه ترین",
    type: "CreateDate desc",
  };

  constructor(
    private readonly libraryService: LibraryService,
    private readonly httpService: HttpService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly tokenService: TokenService,
    private readonly route: Router,
    private readonly navigationBarService: NavigationBarService,
    private readonly indicatorService: IndicatorService) {
    this.isLoading = true;
  }

  ngOnInit(): void {
    this.navigationBarService.prepareNavigationBar();
    this.onTabClicked(this.libraryService.stateTab ?? 'library');
    this.isLoading = true;
    this.indicatorService.hide();
    this.subscription.add(this.tokenService.isLogin$.subscribe(z => {
      this.indicatorService.showHude();
      this.isLogin = z;
      if (z) {
        this.init(this.sortListSelected);
      } else {
        this.indicatorService.hideHude();
        this.isLoading = false;
      }
    }));
  }

  private init(item) {
    forkJoin({
      bought: this.httpService.post<Array<iModalSummary>>(`/api/library/summary?$top=10&$orderby=${item.type}`, {}).pipe(map(z => z.items)),
      bookmark: this.httpService.post<Array<iModalSummary>>(`/api/wishlist/summary?$top=10&$orderby=${item.type}`, {}).pipe(map(z => z.items))
    }).subscribe(z => {
      this.boughtsItem = z.bought;
      this.bookmarkItem = z.bookmark;
      this.visible = false;
      this.indicatorService.hideHude();
      this.sortListSelected = item;
      this.isLoading = false;
    }, () => this.isLoading = false);
  }

  public goToLoginPage() {
    this.route.navigate(['auth'], {queryParams: {returnUrl: 'library'}}).then();
  }

  public goToShopPage() {
    this.route.navigate(['shop']).then(_ => this.navigationBarService.prepareNavigationBar());
  }

  public onShowAll(id, title, type) {
    this.indicatorService.show();
    this.route.navigate(['list', id], {relativeTo: this.activatedRoute, queryParams: {title, type}}).then();
  }

  public showContextMenu(event, type: 'bookmark' | 'library') {
    const {identifier, audiobookId, title, subscriptionStatus, isOwner} = event;
    this.identifierContextMenu = identifier;
    this.audiobookIdContextMenu = audiobookId;
    this.audiobookTitleContextMenu = title;
    this.tabNameContextMenu = type;
    this.subscriptionContextMenu = subscriptionStatus;
    this.isShowContextMenu = true;
    if (type === 'bookmark')
      this.isOwner = isOwner;
  }

  public selected(item) {
    this.isLoading = true;
    this.sortListSelected = item;
    this.boughtsItem = [];
    this.bookmarkItem = [];
    this.indicatorService.showHude();
    this.init(item);
  }

  public showSortList() {
    this.visible = true;
  }

  public onRefreshData() {
    this.bookmarkItem = this.boughtsItem = [];
    this.isLoading = true;
    this.indicatorService.showHude();
    this.init(this.sortListSelected);
    this.onCloseContextMenu();
  }

  public onCloseContextMenu() {
    this.isShowContextMenu = false;
    this.identifierContextMenu =
      this.audiobookIdContextMenu =
        this.audiobookTitleContextMenu =
          this.subscriptionContextMenu = null;
  }

  public onTabClicked(type: 'bookmark' | 'library'): void {
    this.tabNameContextMenu = this.libraryService.stateTab = type;
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
